module.exports = __webpack_public_path__ + "static/img/elong (2).6f0c5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/elong (2).png
// module id = Xlyo
// module chunks = 3